goog.provide("shadow.js.shim.module$$mui$x_tree_view$hooks");
goog.provide("module$shadow_js_shim_module$$mui$x_tree_view$hooks");
shadow.js.shim.module$$mui$x_tree_view$hooks = shadow.js.nativeProvides["@mui/x-tree-view/hooks"] = shadow$bridge("@mui/x-tree-view/hooks");
module$shadow_js_shim_module$$mui$x_tree_view$hooks.default = shadow.js.shim.module$$mui$x_tree_view$hooks;
